import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { store } from "../redux/store";
import { resetUser, setAuthData } from "../redux/user/user.actions";
import { resetCommonReducer } from "../redux/common/common.actions";
import triggerSleepClient from "../services/timeout-services";

export default function useTabGuard() {
  const dispatch = useDispatch();

  useEffect(() => {
    const navEntries = performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];

    const navType = navEntries[0]?.type;

    const existingTabId = sessionStorage.getItem("tabId");

    if (!existingTabId) {
      sessionStorage.setItem("tabId", Date.now().toString());
    } else {
      if (navType !== "reload") {
        localStorage.clear();
        sessionStorage.clear();
        store.dispatch(resetUser());
        store.dispatch(setAuthData({}));
        window.location.replace("#/login");
        window.location.reload();
        store.dispatch(resetCommonReducer());
        triggerSleepClient.stopTimers();
      }
    }
  }, [dispatch]);
}
